export default {
  toPrice (value) {
    return '$' + Number(value).toLocaleString('en-US')
  }

  // finalPrice (price, msrp) {
  //   const x = price || msrp || 0

  //   if (!Number.isInteger(x)) {
  //     return x
  //   }

  //   return x === 0
  //     ? 'Call For Price'
  //     : this.toPrice(x)
  // }
}



// WEBPACK FOOTER //
// ./scripts/src/helpers/price.helper.js